import api from "@/api";

const state = {
    // this is used for preview message when edit notification of a survey
    previewSend: {
        kickoff: false,
        reminder: false,
    },
};

const getters = {
    previewSend(state) {
        return state.previewSend;
    },
};

const actions = {
    sendPreview({ commit }, { payload: { data } }) {
        const type = data.type;
        return api.post(`/api/surveys/notification/preview/send`, data).then(() => {
            if (type === "kickoff") {
                commit("updatePreviewSend", { kickoff: true });
            } else {
                commit("updatePreviewSend", { reminder: true });
            }
        });
    },
};

const mutations = {
    updatePreviewSend(state, v) {
        state.previewSend = { ...state.previewSend, ...v };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
